export default __webpack_public_path__ + "static/media/Olga Lembo.889c7719.png";